export default "__VITE_ASSET__BkUpXYgZ__"